app.controller('AddAddresseeWindowController', ['$scope','DocumentsService', 'OrganizationalUnit', 'usSpinnerService', "$uibModalInstance",
    function ($scope, DocumentsService, OrganizationalUnit, usSpinnerService, $uibModalInstance) {
        $scope.selected = false;
        $scope.addressee = {
            type: 'employee',
            deadLine: null, //(თუ ბოლო ვადა არ აქვს, მაშინ უვადოა)
            level: null,
            resolution : false,
            info: {}
        };

        $scope.levels = [1, 2, 3];

        $scope.dateOptions = {
            "is-open": "false",
            dateDisabled: false,
            formatYear: 'yyyy',
            minDate: new Date(),
            startingDay: 1
        };

        $scope.popup1 = {
            opened: false
        };

        $scope.open1 = function () {
            $scope.popup1.opened = true;
        };

        $scope.changeType = function (type){
            $scope.addressee.type = type;
        };

        function fetchRootUnits() {
            usSpinnerService.spin('root');
            return OrganizationalUnit.getRoots()
                .then(function (roots) {
                    roots.forEach(function (item) {
                        item.children = [];
                        item.parentNode = null;
                    });

                    $scope.unitsTree = roots || [];

                    usSpinnerService.stop('root');
                });
        }

        fetchRootUnits();

        function fetchChildren(unit) {
            usSpinnerService.spin('root');
            return OrganizationalUnit.getChildren(unit._id)
                .then(function (children) {
                    children.forEach(function (item) {
                        item.children = [];
                        item.parentNode = unit;
                    });

                    unit.children = children;

                    usSpinnerService.stop('root');
                });
        }

        $scope.toggleChildren = function (unit) {
            if (unit.expanded) {
                unit.expanded = false;

                return;
            }

            fetchChildren(unit)
                .then(function () {
                    unit.expanded = true;
                });
        };



        $scope.getEmployees = function (query) {
            if (query.length < 2) {
                return [];
            }
            $scope.selected = false;
            return DocumentsService.staffList({query: query}).then(function (data) {
                return data.docs.filter(function (usr) {
                    var el_index = _.findIndex($scope.users, function (user) {
                        return user._id === usr._id;
                    });
                    return el_index === -1;
                })
            });
        };

        $scope.$watch('employee', function (val) {
            if (val && val._id) {
                $scope.selected = true;
            }
        }, true);

        $scope.save = function (el) {
            if($scope.addressee.type == 'employee') {
                $scope.addressee.info = $scope.employee;
                $uibModalInstance.close($scope.addressee);
            }
            else {
                $scope.addressee.info = el;
                $uibModalInstance.close($scope.addressee);
            }
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }]);
